module.exports = __webpack_public_path__ + "assets/icon-gift-small.5f40d350.svg";